import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { overrideOrganizationHeader } from '@cast/api-client';

export const ORGANIZATION_SETTINGS_QUERY_KEY = 'organization-settings';
export const getOrganizationSettingsQueryKey = (params: {
  organizationId?: string;
}) => [ORGANIZATION_SETTINGS_QUERY_KEY, params.organizationId] as const;

export const getOrganizationSettingsQueryOptions = ({
  organizationId,
  enabled = true,
}: {
  organizationId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getOrganizationSettingsQueryKey({ organizationId }),
    queryFn: async () => {
      const { data } =
        await apiClient.organizationSettings.getOrganizationSettings(
          {
            organizationId: organizationId!,
          },
          {
            headers: overrideOrganizationHeader(organizationId),
          }
        );

      return data;
    },
    enabled: enabled && !!organizationId,
    refetchOnWindowFocus: false,
    retryOnMount: false,
  });

export const useOrganizationSettingsQuery = ({
  organizationId,
  enabled = true,
}: {
  organizationId?: string;
  enabled?: boolean;
}) =>
  useQuery(
    getOrganizationSettingsQueryOptions({
      organizationId: organizationId!,
      enabled,
    })
  );
